module.exports = __webpack_public_path__ + "static/media/Autopsy_Digital_Forensics_Logo.8ce70cbc.png";